import { compose, withProps, setPropTypes } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { createHocBase } from "app/utils";
import hash from "object-hash";
import PropTypes from "prop-types";
import * as actions from "./actions";

const selectRatingState = (state, props) => {
  const params = props.ratingParams;
  let ratings = state.ratings[params.id];
  return {
    ratings
  };
};

const createRatingActions = dispatch => bindActionCreators(actions, dispatch);

const queryConditional = props => {
  const { queryRatings, ratingParams, ratings } = props;
  if (ratingParams && !ratings) {
    queryRatings(ratingParams);
  }
};

export const queryRatings = Component =>
  class extends createHocBase(Component) {
    componentDidMount(prevProps) {
      queryConditional(this.props);
    }
    componentDidUpdate(prevProps) {
      const params = this.props.ratingParams;
      const prevParams = prevProps.ratingParams;
      if (prevParams.id === params.id) return;
      queryConditional(this.props);
    }
  };

export const connectRatingState = connect(selectRatingState);

export const connectRatingActions = connect(null, createRatingActions);

const createRatingParams = props => {
  const { proposalId } = props;
  const id = hash({ proposalId });
  const ratingParams = { id, proposalId };
  return {
    ratingParams
  };
};

export const withRatings = compose(
  setPropTypes({
    proposalId: PropTypes.string.isRequired,
    userId: PropTypes.string
  }),
  withProps(createRatingParams),
  connectRatingState,
  connectRatingActions,
  queryRatings
);



// WEBPACK FOOTER //
// ./src/app/ratings/hocs.js